import React from "react"
import "./Portfolio.scss"
import { images } from '../../constants'
import  Tilt  from 'react-parallax-tilt'
import {motion} from 'framer-motion'
const scaleVarience={
  whileInView:{
    scale:[0,1],
    opacity:[0,1],
    transition:{
      duration:0.5,
      ease:'easeInOut'
    },

  },
};

const Portfolio = () => {
  return (
    <>
      <section className='Portfolio top' id='certification'>
        <div className='container'>
          <div className='heading text-center '>

            <h1>My Certification</h1>
          </div>

          <div className='content grid'>
            <motion.div
             varience={scaleVarience}
             whileInView={scaleVarience.whileInView}
             >
            <Tilt glareEnable={true} glareMaxOpacity={0.8} glareColor="#ffffff" glarePosition="bottom" glareBorderRadius="20px">
            <div className='box btn_shadow '>
              <div className='img'>
                  <img src={images.cir1} alt='' />
              </div>
              <div className='category d_flex'>
                  <span>COURSERA CERTIFICATION</span>
                  <label>
                    < i class="fas fa-thin fa-calendar-check"></i> March , 2023
                  </label>
              </div>
              <div className='title'>
                  <h2>IBM Data Analyst</h2>
                
              </div>
            </div>
            </Tilt>
            </motion.div>
            <motion.div
             varience={scaleVarience}
             whileInView={scaleVarience.whileInView}
             >
            <Tilt glareEnable={true} glareMaxOpacity={0.8} glareColor="#ffffff" glarePosition="bottom" glareBorderRadius="20px">
            <div className='box btn_shadow '>
              <div className='img'>
                  <img src={images.cir2} alt='' />
              </div>
              <div className='category d_flex'>
                  <span>COURSERA CERTIFICATION</span>
                  <label>
                    <i className='fas fa-thin fa-calendar-check'></i> March , 2023
                  </label>
              </div>
              <div className='title'>
                  <h2>Google Finance Data Analytics</h2>
               
              </div>
            </div>
            </Tilt>
            </motion.div>
            <motion.div
             varience={scaleVarience}
             whileInView={scaleVarience.whileInView}
             >
            <Tilt glareEnable={true} glareMaxOpacity={0.8} glareColor="#ffffff" glarePosition="bottom" glareBorderRadius="20px">
            <div className='box btn_shadow '>
              <div className='img'>
                  <img src={images.cir3} alt='' />
              </div>
              <div className='category d_flex'>
                  <span>COURSERA CERTIFICATION</span>
                  <label>
                    <i className='fas fa-thin fa-calendar-check'></i> March , 2023
                  </label>
              </div>
              <div className='title'>
                  <h2>Google Data Analytics</h2>
                
              </div>
            </div>
            </Tilt>
            </motion.div>
            <motion.div
             varience={scaleVarience}
             whileInView={scaleVarience.whileInView}
             >
            <Tilt glareEnable={true} glareMaxOpacity={0.8} glareColor="#ffffff" glarePosition="bottom" glareBorderRadius="20px">
            <div className='box btn_shadow '>
              <div className='img'>
                  <img src={images.cir4} alt='' />
              </div>
              <div className='category d_flex'>
                  <span>GOOGLE CERTIFICATTION</span>
                  <label>
                    <i className='fas fa-thin fa-calendar-check'></i> March , 2023
                  </label>
              </div>
              <div className='title'>
                  <h2>Google Analytics</h2>
               
              </div>
            </div>
            </Tilt>
            </motion.div>
            <motion.div
             varience={scaleVarience}
             whileInView={scaleVarience.whileInView}
             >
            <Tilt glareEnable={true} glareMaxOpacity={0.8} glareColor="#ffffff" glarePosition="bottom" glareBorderRadius="20px">
            <div className='box btn_shadow '>
              <div className='img'>
                  <img src={images.cir5} alt='' />
              </div>
              <div className='category d_flex'>
                  <span>AWS CERTIFICATTION</span>
                  <label>
                    <i className='fas fa-thin fa-calendar-check'></i> February , 2023
                  </label>
              </div>
              <div className='title'>
                  <h2>AWS Data Analytics</h2>
               
              </div>
            </div>
            </Tilt>
            </motion.div>
            <motion.div
             varience={scaleVarience}
             whileInView={scaleVarience.whileInView}
             >
            <Tilt glareEnable={true} glareMaxOpacity={0.8} glareColor="#ffffff" glarePosition="bottom" glareBorderRadius="20px">
            <div className='box btn_shadow '>
              <div className='img'>
                  <img src={images.cir6} alt='' />
              </div>
              <div className='category d_flex'>
                  <span>COURSERA CERTIFICATTION</span>
                  <label>
                    <i className='fas fa-thin fa-calendar-check'></i> FEBRUARY , 2023
                  </label>
              </div>
              <div className='title'>
                  <h2>AWS Cloud Practitioner</h2>
               
              </div>
            </div>
            </Tilt>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Portfolio
